import { useEffect } from "react";
import { createPortal } from "react-dom";
import { QRCodeSVG } from "qrcode.react";
import { useAuth } from "@/context/AuthContext";
import { dt, money } from "@/lib/api";

// card: { ear_tag, price, section, worker_name, selected_at, number?, draft? }
export default function BlueCardPrint({ card, onDone }) {
  const { settings } = useAuth();
  useEffect(() => {
    const done = () => { document.body.classList.remove("printing-card"); onDone(); };
    document.body.classList.add("printing-card");
    window.addEventListener("afterprint", done, { once: true });
    const t = setTimeout(() => window.print(), 350);
    return () => { clearTimeout(t); window.removeEventListener("afterprint", done); document.body.classList.remove("printing-card"); };
  }, [onDone]);
  const row = (k, v) => <div className="flex justify-between gap-2 border-b border-dashed border-black py-1"><span>{k}</span><b className="text-left">{v}</b></div>;
  return createPortal(
    <div id="card-print-root" dir="rtl" data-testid="blue-card-print">
      <style>{"@page { size: 80mm auto; margin: 3mm; }"}</style>
      <div className="text-center font-black text-base">{settings?.org_name || "الربيع للأضاحي"}</div>
      <div className="text-center font-bold border-y-2 border-black my-1 py-1">البطاقة الزرقاء – اختيار كبش</div>
      {card.draft && <div className="text-center font-black border-2 border-black my-1 p-1" data-testid="blue-card-draft-flag">غير مسجلة في النظام – مسودة</div>}
      <div className="text-center text-xs">رقم الكبش</div>
      <div className="text-center font-black num" style={{ fontSize: "40px", lineHeight: 1.1 }}>{card.ear_tag}</div>
      {row("السعر المتفق عليه", money(card.price))}
      {row("القسم", card.section)}
      {row("العامل", card.worker_name)}
      {row("تاريخ ووقت الاختيار", dt(card.selected_at))}
      {card.number && row("رقم السجل", card.number)}
      {!card.draft && card.number && (
        <div className="flex justify-center my-2"><QRCodeSVG value={`${window.location.origin}/selections?q=${encodeURIComponent(card.ear_tag)}`} size={110} level="M" /></div>
      )}
      <div className="mt-6 border-t border-black pt-1 text-center text-xs">توقيع العامل</div>
      <div className="text-center text-[10px] mt-2">يُقدّم الزبون هذه البطاقة لمكتب المبيعات لإتمام البيع. ليست وصل بيع ولا تصريح خروج.</div>
    </div>,
    document.body,
  );
}
